import { flattenBlocks } from './flatten';

/** True if the tree already has a variables table block (one per doc max). */
export const hasVariablesBlock = (blocks) =>
  flattenBlocks(blocks).some((b) => b.type === 'variables');

/**
 * Drop surplus `variables` blocks from a pasted/inserted tree so a doc never
 * gains a second variables table. When `allowOne` is true (doc has none yet),
 * the first variables block in document order is kept.
 */
export const limitVariablesBlocks = (blocks, { allowOne = false } = {}) => {
  let kept = !allowOne;
  const walk = (list) =>
    (list || [])
      .map((block) => {
        if (block.type === 'variables') {
          if (kept) return null;
          kept = true;
          return block;
        }
        if (block.children?.length) {
          const children = walk(block.children);
          return children === block.children ? block : { ...block, children };
        }
        return block;
      })
      .filter(Boolean);
  return walk(blocks);
};
